import { ref } from 'vue';

const isAuthenticated = ref(false);

const userStore = {
  isAuthenticated,
  login() {
    isAuthenticated.value = true;
  },
  logout() {
    isAuthenticated.value = false;
  },
};

export { userStore };
